import { Toast } from "@homebound/beam";
import { PropsWithChildren } from "react";
import { DownloadTracker } from "src/components/DownloadTracker";
import { ErrorBoundary } from "src/components/ErrorBoundary";

/** Toast, and error boundary below the global nav. Shared by legacy and migrated routes. */
export function LoggedInPageWrapper(props: PropsWithChildren) {
  return (
    <>
      <Toast />
      <DownloadTracker />
      <ErrorBoundary>{props.children}</ErrorBoundary>
    </>
  );
}
